import * as types from "../actions/ActionTypes";
import InitialState from "./InitialState";

export default function HoursTransactionTypesReducer(
  state = InitialState.hoursTransationTypes,
  action
) {
  switch (action.type) {
    case types.LOAD_HOURS_TRANSACTION_TYPES_SUCCESS:
      return action.typeList;
    default:
      return state;
  }
}
